<template>
  <div v-if="params.value">
    <div>
      <b-button
        id="show-btn"
        size="sm"
        @click="$bvModal.show(tempId)"
      >
        View Content
      </b-button>
    </div>

    <b-modal
      :id="tempId"
      hide-header
      hide-footer
    >
      <div
        class="text-left"
        v-html="display"
      >
        {{ display }}
      </div>
      <b-button
        class="mt-3"
        block
        @click="$bvModal.hide(tempId)"
      >
        Close Me
      </b-button>
    </b-modal>
  </div>
</template>

<script>

import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin],
  data: function() {
    return {
      value: null,
      tempId: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString()
    }
  }
}
</script>
